import { createRecipe } from './runtime.js';

const radioGroupConfig = {"name":"radioGroup","defaultVariants":{"orientation":"vertical"},"variantMap":{"orientation":["horizontal","vertical"]}}

export const radioGroup = /* @__PURE__ */ createRecipe(radioGroupConfig)